/** Scrub sensitive values before shipping extras to Sentry (F-044 / mirrors backend log_scrub). */

const SENSITIVE_KEY =
  /(password|passwd|secret|token|authorization|api[_-]?key|access[_-]?key|refresh[_-]?token|id[_-]?token|client[_-]?secret|private[_-]?key|credential)/i

const REDACTED = '[REDACTED]'

export function scrubSensitive(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map((item) => scrubSensitive(item))
  }
  if (value !== null && typeof value === 'object') {
    const out: Record<string, unknown> = {}
    for (const [key, item] of Object.entries(value as Record<string, unknown>)) {
      out[key] = SENSITIVE_KEY.test(key) ? REDACTED : scrubSensitive(item)
    }
    return out
  }
  return value
}
